import ApiService from './api';

export default class ConfigService extends ApiService{
  async getConfig(){
    return this.get( '/config/');
  }

}

